/**
 * 健康管理路由保护组件
 * 仅系统管理员 或 拥有 health.view 权限的用户可访问
 */
import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { hasHealthPermission } from '../utils/healthAuth';

const HealthRoute = ({ children }) => {
  const location = useLocation();
  const [hasPermission, setHasPermission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        const ok = await hasHealthPermission();
        setHasPermission(ok);
      } catch {
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    check();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!hasPermission) {
    setTimeout(() => {
      const userStr = localStorage.getItem('user');
      let tip = '';
      if (userStr) {
        try {
          const u = JSON.parse(userStr);
          tip = `（当前用户: ${u.name || u.email}）`;
        } catch (e) {
          /* ignore */
        }
      }
      alert(
        `您没有健康管理权限，请联系管理员分配「健康用户」或「个人产品管理员」角色${tip}`
      );
    }, 100);
    return <Navigate to="/" replace />;
  }

  return children;
};

export default HealthRoute;
